<script>
  import { getContext } from "svelte"
  import { useQueryClient } from "@sveltestack/svelte-query"
  import {
    useDispatchingViewStylesQuery
  } from "../../../../../hooks/project/views/dispatchingView/useDispatchingViewStylesQuery.js"
  import {
    prefetchDispatchingViewResourceDetail,
    useDispatchingViewResourceDetailQuery,
  } from "../../../../../hooks/project/views/dispatchingView/useDispatchingViewResourceDetailQuery.js"
  import {
    useDispatchingViewResourcesQuery
  } from "../../../../../hooks/project/views/dispatchingView/useDispatchingViewResourcesQuery.js"
  import EnsureFetchedQueries from "../../../../functional/EnsureFetchedQueries.svelte";
  import { useGlobalProjectDataQuery } from "../../../../../hooks/project/views/useGlobalProjectDataQuery.js";
  import FetchTransactionsForDispatchingView from "./FetchTransactionsForDispatchingView.svelte";

  // props
  /**
   * @type {string}
   */
  export let projectId

  /**
   * @type {string}
   */
  export let itemCode

  /**
   * This prop will determine at what interval the data will be refetched.
   * Set this to "false" to disable refetching, or provide refetching interval in milliseconds.
   * @type {false|number}
   */
  export let refetchInterval = false

  // error handlers
  const {handleFetchErrors} = getContext("fetchErrorHandler")

  // svelte-query
  const stylesQueryResult = useDispatchingViewStylesQuery(projectId, handleFetchErrors, refetchInterval)
  $: resourceDetailQueryResult = useDispatchingViewResourceDetailQuery(projectId, itemCode, handleFetchErrors, refetchInterval)
  const resourceGroupQueryResult = useDispatchingViewResourcesQuery(projectId, handleFetchErrors, refetchInterval)
  const globalProjectDataQueryResult = useGlobalProjectDataQuery(projectId, handleFetchErrors, refetchInterval)

  // prefetch
  const queryClient = useQueryClient()
  let prefetchedResourceObjectIds = []
  $: prefetchedResourceObjectIds
    .filter(objectId => !!objectId)
    .forEach(objectId => prefetchDispatchingViewResourceDetail(queryClient, projectId, objectId))
  export const setPrefetchedResourceObjectIds = (ids) => prefetchedResourceObjectIds = ids

  $: lastDownloadedTimeStamp = $resourceDetailQueryResult.data?.DownloadTimeStamp
  $: ({
    resources,
    resourceGroups,
    isCustomizedForProfile1,
  } = $resourceGroupQueryResult.data ?? {resources: [], resourceGroups: [], isCustomizedForProfile1: false})
</script>

<FetchTransactionsForDispatchingView
  projectId={projectId}
  resourceObjectId={itemCode}
  downloadTimestamp={lastDownloadedTimeStamp}
  refetchInterval={refetchInterval}
  enabled={!$resourceDetailQueryResult.isLoading}
  let:transactions
  let:postTransaction
  let:reloadTransactions
  let:resetTransactions
  let:isInputAllowed
>
  <EnsureFetchedQueries
    queries={[
      $stylesQueryResult,
      $resourceGroupQueryResult,
      $resourceDetailQueryResult,
      $globalProjectDataQueryResult,
    ]}
  >
    <slot
      projectId={projectId}
      isCustomizedForProfile1={isCustomizedForProfile1}
      resources={resources}
      resourceGroups={resourceGroups}
      styles={$stylesQueryResult.data}
      resourceDetail={$resourceDetailQueryResult.data}
      transactions={transactions}
      postTransaction={postTransaction}
      reloadTransactions={reloadTransactions}
      resetTransactions={resetTransactions}
      isInputAllowed={isInputAllowed}
      globalProjectData={$globalProjectDataQueryResult.data}
      setPrefetchedResourceObjectIds={setPrefetchedResourceObjectIds}
    />
  </EnsureFetchedQueries>
</FetchTransactionsForDispatchingView>
